import { FC } from "react";
import { Box, Theme } from "@mui/material";
import { Formik, FormikHelpers } from "formik";
import { Modal, ModalProps } from "@vilocnv/allsetra-core";
import InnerForm from "./children/InnerForm";
import { useTranslation } from "react-i18next";
import { getResetFilterFormValues } from "app/data/helpers/ReportHelpers";

export type ReportsCommonFormProps = Pick<ModalProps, "open" | "onClose"> & {
  onSubmit: (values: any, formikHelpers: FormikHelpers<any>) => void;
  theme: Theme;
  dataLoading?: boolean;
  groups: Array<any>;
  objectTypes: Array<any>;
  objects: Array<any>;
  keys: Array<any>;
  submitting?: boolean;
  fetchOnDebounce: (value: string) => void;
  onChange?: (val?: any) => void;
  isCO2InnerForm?: boolean;
  formInitialValues?: {};
  formValidations?: {};
  isMultipleRidesForm?: boolean;
  isMileageReport?: boolean;
  reportType?: number;
  users?: Array<any>;
  showDateRangePicker?: boolean;
  dateValues?: any;
  handleDateChange?: (value: any) => void;
  dateRangeLoading?: boolean;
  driverIsRequired?: boolean;
  onResetFilters?: () => void;
};

const ReportsCommonFilterForm: FC<ReportsCommonFormProps> = ({
  open,
  onClose,
  onSubmit,
  theme,
  dataLoading = false,
  groups,
  objects,
  objectTypes,
  keys,
  submitting = false,
  fetchOnDebounce,
  onChange,
  isCO2InnerForm = false,
  formInitialValues,
  formValidations,
  isMultipleRidesForm = false,
  isMileageReport = false,
  reportType = 2,
  users,
  showDateRangePicker = false,
  dateValues,
  handleDateChange,
  dateRangeLoading = false,
  driverIsRequired = false,
  onResetFilters
}) => {
  const { t } = useTranslation(["translation", "formFieldsTranslation"]);

  return (
    <Formik
      //@ts-ignore
      initialValues={formInitialValues}
      validationSchema={formValidations}
      onSubmit={onSubmit}
      enableReinitialize
      validateOnMount
    >
      {({
        handleSubmit,
        isSubmitting,
        isValid,
        values,
        setFieldValue,
        resetForm
      }) => (
        <Modal
          title="Filters"
          theme={theme}
          open={open}
          onClose={() => {
            onClose();
          }}
          secondaryBtnProps={{
            text: t("buttonsText.cancel"),
            onClick: onClose
          }}
          primaryBtnProps={{
            type: "submit",
            text: t("buttonsText.apply"),
            loading: isSubmitting || submitting,
            // @ts-ignore
            onClick: handleSubmit,
            disabled: !isValid
          }}
          size="customSize"
        >
          <>
            <InnerForm
              groups={groups}
              objectTypes={objectTypes}
              objects={objects}
              keys={keys}
              dataLoading={dataLoading}
              translator={t}
              fetchOnDebounce={fetchOnDebounce}
              onChange={onChange}
              //@ts-ignore
              values={values}
              setFieldValue={setFieldValue}
              isCO2InnerForm={isCO2InnerForm}
              isMultipleRidesForm={isMultipleRidesForm}
              isMileageReport={isMileageReport}
              reportType={reportType}
              users={users}
              showDateRangePicker={showDateRangePicker}
              dateValues={dateValues}
              handleDateChange={handleDateChange}
              dateRangeLoading={dateRangeLoading}
              driverIsRequired={driverIsRequired}
            />
            <Box mt={2} display="flex" justifyContent="flex-start">
              <button
                type="button"
                onClick={() => {
                  const resetValues = getResetFilterFormValues(
                    formInitialValues as Record<string, any>
                  );
                  resetForm({ values: resetValues });
                  onChange?.([]);
                  onResetFilters?.();
                  fetchOnDebounce("");
                }}
                style={{
                  background: "transparent",
                  border: "none",
                  color: theme.palette.primary.main,
                  cursor: "pointer",
                  textDecoration: "underline",
                  fontSize: 14,
                  padding: 0
                }}
              >
                {t("buttonsText.reset", { defaultValue: "Reset filters" })}
              </button>
            </Box>
          </>
        </Modal>
      )}
    </Formik>
  );
};

export default ReportsCommonFilterForm;
